import { render, staticRenderFns } from "./OnboardingMultiLista.vue?vue&type=template&id=0dff77ae"
import script from "./OnboardingMultiLista.vue?vue&type=script&lang=js"
export * from "./OnboardingMultiLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports